import { BoxDetailViewModel } from "./Model/box.viewModel";

export class FavoriteDataSource {
  public favorites: Map<string, any> = new Map<string, any>();
  public favoritesByObjectType: BoxDetailViewModel[][] = [];
  public appObjectTypesKeys = [330001152, 330001206, 330001137];
  constructor(data: any) {
    if (data.length) {
      data.forEach((favorite: any) => {
        if (this.appObjectTypesKeys.includes(favorite.ParentObjectType)) {
          const favoriteViewModel = new BoxDetailViewModel(favorite);
          this.favorites.set(favoriteViewModel.ParentId, favoriteViewModel);

          if (this.favoritesByObjectType[favoriteViewModel.ParentObjectType]) {
            this.favoritesByObjectType[favoriteViewModel.ParentObjectType].push(
              favoriteViewModel,
            );
          } else {
            this.favoritesByObjectType[favoriteViewModel.ParentObjectType] = [
              favoriteViewModel,
            ];
          }
        }
      });
    }
  }

  public setDisplayText(ObjectType: string, data: any): void {
    if (Array.isArray(data)) {
      data.forEach((favorite) => {
        const eleme = this.favorites.get(favorite.Id);
        if (eleme && String(eleme.ParentObjectType) === ObjectType) {
          eleme.DisplayText = favorite.DisplayText;
          eleme.MeasureTaskParentId = favorite.MeasureTaskParentId;
        }
      });
    }
  }

  public deleteFavoriteFromList(id: string): void {
    this.favorites.forEach((value, key) => {
      if (value.Id === id) {
        this.favorites.delete(key);
      }
    });
  }
}
